import { WebUser } from 'store/ducks/users/types';

/*
 * Action Types
 */
export enum GroupsTypes {
  LIST_GROUPS_REQUEST = '@supervisorsGroups/LIST_GROUPS_REQUEST',
  LIST_GROUPS_SUCCESS = '@supervisorsGroups/LIST_GROUPS_SUCCESS',
  LIST_GROUPS_FAILURE = '@supervisorsGroups/LIST_GROUPS_FAILURE',

  FILTER_GROUPS_REQUEST = '@supervisorsGroups/FILTER_GROUPS_REQUEST',
  FILTER_GROUPS_SUCCESS = '@supervisorsGroups/FILTER_GROUPS_SUCCESS',
  FILTER_GROUPS_FAILURE = '@supervisorsGroups/FILTER_GROUPS_FAILURE',

  GET_GROUP_REQUEST = '@supervisorsGroups/GET_GROUP_REQUEST',
  GET_GROUP_SUCCESS = '@supervisorsGroups/GET_GROUP_SUCCESS',
  GET_GROUP_FAILURE = '@supervisorsGroups/GET_GROUP_FAILURE',

  CREATE_GROUP_REQUEST = '@supervisorsGroups/CREATE_GROUP_REQUEST',
  CREATE_GROUP_SUCCESS = '@supervisorsGroups/CREATE_GROUP_SUCCESS',
  CREATE_GROUP_FAILURE = '@supervisorsGroups/CREATE_GROUP_FAILURE',

  UPDATE_GROUP_REQUEST = '@supervisorsGroups/UPDATE_GROUP_REQUEST',
  UPDATE_GROUP_SUCCESS = '@supervisorsGroups/UPDATE_GROUP_SUCCESS',
  UPDATE_GROUP_FAILURE = '@supervisorsGroups/UPDATE_GROUP_FAILURE',

  DELETE_GROUP_REQUEST = '@supervisorsGroups/DELETE_GROUP_REQUEST',
  DELETE_GROUP_SUCCESS = '@supervisorsGroups/DELETE_GROUP_SUCCESS',
  DELETE_GROUP_FAILURE = '@supervisorsGroups/DELETE_GROUP_FAILURE',
}

/*
 * Data types
 */
export interface GroupInterface {
  id: string;
  name: string;
  companyId: string;
  users: WebUser[];
  createdAt?: string;
  updatedAt?: string;
}

/*
 * State type
 */
export interface SupervisorsGroupsState {
  readonly groupsList: GroupInterface[];
  readonly groupData: GroupInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
